import { NamingConvention } from "namirasoft-core";
import { NSBaseMetaDatabase } from "namirasoft-site";

// Bar
export * from "./components/NSBarAction";
export * from "./components/NSBarAlert";
export * from "./components/NSBarNotification";
export * from "./components/NSBarTitle";

// Banner
export * from "./components/NSBanner";

// Box
export * from "./components/INSBox";
export * from "./components/NSBox";
export * from "./components/NSBoxBaseLayout";
export * from "./components/NSBoxBaseCombo";
export * from "./components/NSBoxBoolean";
export * from "./components/NSBoxBooleans";
export * from "./components/NSBoxCombo";
export * from "./components/NSBoxDate";
export * from "./components/NSBoxDateTime";
export * from "./components/NSBoxDouble";
export * from "./components/NSBoxDuration";
export * from "./components/NSBoxDynamic";
export * from "./components/NSBoxDynamics";
export * from "./components/NSBoxEmail";
export * from "./components/NSBoxEntity";
export * from "./components/NSBoxEnum";
export * from "./components/NSBoxFile";
export * from "./components/NSBoxIPV4";
export * from "./components/NSBoxIPV6";
export * from "./components/NSBoxInteger";
export * from "./components/NSBoxMoney";
export * from "./components/NSBoxPassword";
export * from "./components/NSBoxPhone";
export * from "./components/NSBoxRadio";
export * from "./components/NSBoxSchemaBase";
export * from "./components/NSBoxSchemaVariable";
export * from "./components/NSBoxSearch";
export * from "./components/NSBoxString";
export * from "./components/NSBoxTextArea";
export * from "./components/NSBoxTime";
export * from "./components/NSBoxTimeZone";
export * from "./components/NSBoxURL";
export * from "./components/NSBoxVersion";

// Button
export * from "./components/NSButton";
export * from "./components/NSButtonBlue";
export * from "./components/NSButtonGreen";
export * from "./components/NSButtonRed";

// Card
export * from "./components/NSCard";
export * from "./components/NSCardScreenshot"

// Chart
export * from "./components/NSChartColumn";
export * from "./components/NSChartDoughnut";
export * from "./components/NSChartPie";
export * from "./components/NSChartRange";
export * from "./components/NSChartTable";

// Copy
export * from "./components/NSCopyBox";
export * from "./components/NSCopy";

// Column
export * from "./components/NSColumn";

// Dialog
export * from "./components/NSDialog";
export * from "./components/NSDialogDelete";
export * from "./components/NSDialogInfo";
export * from "./components/NSDialogPageSelection";

// DownTimer
export * from "./components/NSDownTimer";

// Tile
export * from "./components/NSTile";

// Filter
export * from "./components/NSFilterBox";
export * from "./components/NSFilterBoxItems";
export * from "./components/NSFilterItem";

// Fotter
export * from "./components/NSFooter";

// Header
export * from "./components/NSHeader";

// ID
export * from "./components/NSID";

// Label
export * from "./components/NSLabel";
export * from "./components/NSLabelErrorNotifier";

// Layout
export * from "./components/NSLayout";

// Line
export * from "./components/NSLine";

// Link
export * from "./components/NSLink";
export * from "./components/NSLinkBlue";
export * from "./components/NSLinkGreen";
export * from "./components/NSLinkRed";

// List
export * from "./components/NSListGrouped";
export * from "./components/NSListProduct";

// Loading
export * from "./components/NSLoading";

// Menu
export * from "./components/NSMenuAction";
export * from "./components/NSMenuButton";

// NoData
export * from "./components/NSNoData";

// Pagination
export * from "./components/NSPagination";

// Panel
export * from "./components/NSPanel";
export * from "./components/NSPanelAccordion";

// Repeater
export * from "./components/NSRepeater";
export * from "./components/NSRepeaterNSBoxSchemaVariable";
export * from "./components/NSRepeaterNSTag";

// Row
export * from "./components/NSRow";

// Section
export * from "./components/NSSection";
export * from "./components/NSSectionTiles";
export * from "./components/NSSectionCards";
export * from "./components/NSSectionTitle";

// Space
export * from "./components/NSSpace";

// Table
export * from "./components/NSTable";

// TabPage
export * from "./components/NSTabPage";

// Tag
export * from "./components/NSTag";

// Title
export * from "./components/NSTitle";

// formatter
export * from "./formatter/BackColorFormatter";
export * from "./formatter/BaseColumnFormatter";
export * from "./formatter/BaseURLImageFormatter";
export * from "./formatter/BooleanFormatter";
export * from "./formatter/DateFormatter";
export * from "./formatter/DateTimeFormatter";
export * from "./formatter/DurationFormatter";
export * from "./formatter/EmailFormatter";
export * from "./formatter/EnumFormatter";
export * from "./formatter/FloatFormatter";
export * from "./formatter/ForeColorFormatter";
export * from "./formatter/IDFormatter";
export * from "./formatter/IntegerFormatter";
export * from "./formatter/IPFormatter";
export * from "./formatter/JsonFormatter";
export * from "./formatter/MoneyFormatter";
export * from "./formatter/PhoneFormatter";
export * from "./formatter/StringFormatter";
export * from "./formatter/TimeFormatter";
export * from "./formatter/UnknowFormatter";
export * from "./formatter/URLFormatter";

// pages
export * from "./pages/NSNotFoundPage";
export * from "./pages/NSUpdating";

// props
export * from "./props/IBackgroundProps";
export * from "./props/IBaseComponentProps";
export * from "./props/IHeaderIconProps";
export * from "./props/IHeaderProps";
export * from "./props/IImageProps";
export * from "./props/ILinkProps";
export * from "./props/IValidationNumberProps";
export * from "./props/IValidationPrecisionProps";
export * from "./props/IValidationProps";
export * from "./props/IValidationRegexProps";
export * from "./props/IValidationStringProps";

// routing
export * from "./routing/NSNotifier";
export * from "./routing/NSRouterMaker";
export * from "./routing/NSRouterMakerComponent";
export * from "./routing/NSRouterMakerProps";

export * from "./Validator";
export * from "./NSBoxBuilder";
export * from "./ProductCacheService";
export * from "./CopyToClipboard";

function main()
{
    NSBaseMetaDatabase.getServerBaseURL = function (name: string): string
    {
        name = name.replace("Namirasoft", "").trim();
        name = NamingConvention.auto.convert(name, NamingConvention.UPPER_CASE_UNDERSCORE);
        return `REACT_APP_BASE_URL_${name}`;
    }
}

main();